var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCircleX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M812.5 812.5L487.5 487.5M812.5 487.5L487.5 812.5",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650.001 1191.67C949.155 1191.67 1191.67 949.155 1191.67 650.001C1191.67 350.846 949.155 108.334 650.001 108.334C350.846 108.334 108.334 350.846 108.334 650.001C108.334 949.155 350.846 1191.67 650.001 1191.67Z",
    className: "svgStroke",
    strokeWidth: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCircleX);
export default __webpack_public_path__ + "static/media/akar-icons_circle-x.e102dc86.svg";
export { ForwardRef as ReactComponent };